import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import { TooltipWrapperStyled } from 'approot/shared/tooltip/tooltip.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { ImageFillWrapper } from '../image/image.style';
import { spacing12, spacing16 } from 'approot/shared/styles/spacing.style';
import {
  SecondaryButton,
  SecondaryButtonIcon,
} from 'approot/shared/styles/buttons/secondary-button.style';
import { font16 } from 'approot/shared/styles/typography.style';
import { Box } from 'approot/shared/styles/box.style';

export const PAGE_CONTROL_HEIGHT = 40;

export const SlideshowContainer = styled.figure`
  background-color: ${grey1};
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;

  ${TooltipWrapperStyled} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const SlideshowWrapper = styled(Box).attrs({
  $flexDirection: 'column',
})`
  position: relative;
  height: 100%;
`;

type PagesPreviewImageProps = {
  isLoading: boolean;
};

export const SlideshowPages = styled.div<PagesPreviewImageProps>`
  ${flexCentreAlignCss}

  background-color: transparent;
  border-radius: ${rem(borderRadius8)} ${rem(borderRadius8)} 0 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  ${ImageFillWrapper} {
    border-radius: ${rem(borderRadius8)} ${rem(borderRadius8)} 0 0;
  }

  img {
    background-color: ${grey1};
    ${({ isLoading }) =>
      !isLoading
        ? `
    opacity: 1;
    visibility: visible;
    transition: opacity 600ms ease, visibility 0ms linear;
  `
        : `
    opacity: 0;
    visibility: hidden;
    transition: opacity 0s ease, visibility 0s ease;
  `}
  }
`;

export const SlideshowCaption = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey4};
  position: absolute;
  left: ${rem(spacing12)};
  right: ${rem(spacing12)};
  bottom: ${rem(spacing12)};
  padding: ${rem(spacing12)};
`;

export const SlideshowCaptionButton = styled(SecondaryButtonIcon).attrs({
  $borderRadius: 40,
  $isSmall: true,
})`
  position: absolute;
  right: ${rem(spacing12)};
  top: -${rem(spacing16)};
  z-index: 10;
`;

export const SlideshowCaptionButtonShow = styled(SecondaryButton).attrs({
  $borderRadius: 40,
})`
  position: absolute;
  right: ${rem(spacing12)};
  bottom: ${rem(spacing12)};
  z-index: 10;
`;

export const SlideshowPageControls = styled.div`
  ${flexCentreAlignCss}
  ${font16}

  flex-shrink: 0;
  height: ${rem(PAGE_CONTROL_HEIGHT)};
`;
